<!-- Sign In using OTP  -->
<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <button @click="goBack"  class="text-link mt-2"> Back</button>
            <div class="left-login">
              <div class="rep-icon-login">
                <img
                  src="../../assets/images/member-login.svg"
                  alt="image-fluid"
                />
              </div>
              <div class="">
                <!-- <router-link to="/smart-login">
                  <button class="qr-login-btn">
                    <img
                      src="../../assets/images/qr-icon.svg"
                      alt="qr icon"
                      class="me-2"
                    />Login with QR
                  </button>
                </router-link> -->
              </div>
            </div>
            <h4 class="login-title mb-1">Verify OTP</h4>
            <div class="auth-form pt-1 pb-3">
              <form class="">
                <div class="">
                  <div class="d-flex justify-content-between">
                    <div class="">
                      <label class="opt-label mt-0"
                        >Enter OTP<span class="required-label">*</span></label
                      >
                    </div>
                  </div>
                  <div class="opt-num-wrap">
                    <div>
                      <v-otp-input
                        @on-complete="onChangeOTP"
                        @on-change="handleOnChange"
                        ref="otpInput"
                        :input-classes="errorClass +' otp-input'"
                        separator="-"
                        :num-inputs="6"
                        :should-auto-focus="true"
                        :is-input-num="true"
                    />
                    </div>
                  </div>
                  <div class="valid-error mt-2" v-if="otpErrorFlag">
                  {{ errorMsg }}
                </div>
                </div>
              </form>
              <button :disabled="formLoader" @click="verifyToken" class="submit-btn mt-3 next-btn ml-0" type="button">
                Register
              </button>
             
              <login-otp  @sendOTP="sendOTP" :expirySecond=60 :setSpinnerLoader="otpLoader"/>
            </div>
            <div class="d-flex justify-content-between"></div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding  p-0">
          <login-in-carsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logincarsoule from "./Logincarsoule";
import Helper from "@/resource/Helper";
import NewLoginOtp from "./NewLoginOtp.vue";
// import axios from 'axios'
import Api from "@/resource/MemberApi";
import { captureScreenshot } from "../../utlis/helper";

export default {
  name: "RegisterOtp",
  components: {
    "login-in-carsoule": Logincarsoule,
    "login-otp":NewLoginOtp,
  },
  data: () => {
  return {
    form: {
      email_otp: "",
      phone_otp: "",
      userid: "",
    },
    memberPhone: "",
    memberEmail: "",
    errorClass:'',
    errors: {},
    otpLoader:false,
    formLoader:false,
    otpErrorFlag:false,
    errorMsg:'',
    setSpinnerLoader:false
  };
},
computed: {
  maskedEmail() {
    return Helper.maskEmail(this.memberEmail);
  },
  maskedPhone() {
    return Helper.maskPhone(this.memberPhone);
  },
},
  methods:{
    onChangeOTP(otp){
      let app=this
      app.form.email_otp=otp
      app.form.phone_otp=otp
      app.verifyToken();
    },
    handleOnChange () {
    let app = this;
    if ( app.form.email_otp.length < 6) {
        app.otp =  app.form.email_otp
      }
    if (app.otpErrorFlag) {
      app.otpErrorFlag = false
      app.errorClass = ''
      app.errorMsg = ''
    }
  },
  async verifyToken() {
    let app = this;

    const screenshot = await captureScreenshot();
      if (!screenshot) {
        throw new Error('Screenshot capture failed');
      }

      if ((!app.form.email_otp) || (app.form.email_otp.trim() === "")) {
        app.otpErrorFlag = true;
        app.errorClass = 'highlight_otp'
        app.errorMsg = "Please enter  OTP sent to your registered email  to proceed";
        
      } else if ((app.form.email_otp.length < 6)) {
        app.otpErrorFlag = true;
        app.errorClass = 'highlight_otp'
        app.errorMsg = "Please enter  6 digit OTP inorder to proceed";
      } else {
        app.formLoader = true
        app.errorClass = false;
        let url = "v2/auth/validate-registration-otp";
        let postData = {
          ...this.form,
          screenshot
        }
        
    let loader = this.$loading.show(); 
    Api.post(url,postData, {
      headers: {
        'X-App-Source': 'web'
      }
    })
        .then((res) => {
        Helper.infoMessage(this, res.data.status, res.data.message);
        this.$store.commit("setEmailOtp", this.form.email_otp);
        this.$store.commit("setPhoneOtp", this.form.email_otp);
        this.$router.push({ name: "NewSignUpContinue" });
      })
      .catch((err) => {
         app.errorClass = 'highlight_otp'
         if (err.response.data.status == "error") {
            app.otpErrorFlag = true
            app.errorMsg = err.response.data.message
            app.setSpinnerLoader = false
          }
          app.verifyLoader = false;
        Helper.infoMessage(
          this,
          err.response.data.status,
          err.response.data.message
        );
      }).finally(() => {
      app.formLoader = false;
      app.setSpinnerLoader = false
      loader.hide();
    } );
  }
  },
    goBack() {
    this.$store.commit("setOtpSend", false);
    this.$router.push({ name: "VerifyDetails" });
  },
  handleEmailOtp(value) {
    if (value.length == 4) {
      this.form.email_otp = parseInt(value);
    }
  },
  setData() {
    this.form.userid = this.$store.state.memberId;
    this.memberPhone = this.$store.state.memberPhone;
    this.memberEmail = this.$store.state.memberEmail;
    if (!this.memberPhone || !this.memberEmail) {
      this.$router.push({ name: "NewSignUp" });
    }
    if (!this.$store.state.otpSend) {
      this.$router.push({ name: "VerifyDetails" });
    }
  },

    sendOTP () {
    let app = this;
    app.otpLoader = true;
    let url = "v2/auth/validate-registration-email-phone";
    Api
      .post(url, {
        phone: this.$store.state.memberPhone,
        email: this.$store.state.memberEmail,
        userid: this.$store.state.memberId,
      })
      .then((res) => {
        Helper.infoMessage(this, res.data.status, res.data.message);
      })
      .catch((err) => {
        Helper.infoMessage(
          this,
          err.response.data.status,
          err.response.data.message
        );
      })
      .finally(() => {
        app.otpLoader = false;
      });
    }
  },
  created() {
  this.setData();
},
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
/* .rep-icon-login img {
  width: 100px;
} */
.new-login-wrapper .highlight_otp {
  border: 2px solid #dc3545 !important;
}

.new-login-wrapper .valid-error {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 14px;
}
.resend-timer{
    color: #5e5e5e !important;
    margin-left: 2px;
    font-weight: 600;
}
</style>

<style scoped>
.text-link{
border: none;
background: transparent;
}
</style>